import {
    CONFIRMED_GET_PANCHKARMA_USERS,
    CONFIRMED_ADD_PANCHKARMA_USER,
    CONFIRMED_UPDATE_PANCHKARMA_USER,
    CONFIRMED_DELETE_PANCHAKRMA_USER,
  } from "../../actions/PanchkarmaActions/UserType";
  
  const initialState = {
    panchkarmaUsers: [],
    num_rows: 0, 
  };
  
  export default function panchkarmaUserReducer(state = initialState, action) {
    switch (action.type) {
      // case CONFIRMED_GET_ADMIN_USERS:
      //   return { ...state, adminUsers: action.payload };
      case CONFIRMED_GET_PANCHKARMA_USERS:
        return { 
          ...state, 
          panchkarmaUsers: action.payload.panchkarmaUsers || action.payload,
          num_rows: action.payload.num_rows || 0
        };
      case CONFIRMED_ADD_PANCHKARMA_USER:
        return {
          ...state,
          panchkarmaUsers: [...state.panchkarmaUsers, action.payload],
        };
  
      case CONFIRMED_UPDATE_PANCHKARMA_USER:
        return {
          ...state,
          panchkarmaUsers: state.panchkarmaUsers.map((user) =>
            user.admin_id === action.payload.admin_id ? { ...user, ...action.payload } : user
          ),
        };
  
      case CONFIRMED_DELETE_PANCHAKRMA_USER:
        return {
          ...state,
          panchkarmaUsers: state.panchkarmaUsers.filter(
            (user) => user.admin_id !== action.payload.admin_id
          ),
        };
  
      default:
        return state;
    }
  }
  